export const IMAGES = {
  logos: {
    golden: "/images/CaboYogaFitness_GoldenLogotype.png",
    white: "/images/CaboYogaFitness_WhiteLogotype.png",
  },
  hero: "/images/Hero_CaboYogaFitness.jpg",
  community: "/images/Community_CaboYogaFitness.jpg",
  place: "/images/ThePlace_CaboYogaFitness.jpg",
  intro: "/images/TheStudio_CaboYogaFitness.jpeg",
  about: "/images/YogaBeach_LosCabos_CaboYogaFitness.jpg",
  privateExperiences: "/images/PrivateExperiences_Studio_CaboYogaFitness.jpg",
  finalCta: "/images/FinalCTA_Studio_CaboYogaFitness.jpg",
  lululemon: "/images/lululemon_Yogotype.png",
  classes: {
    vinyasa: "/images/VinyasaYoga_FullBody_CaboYogaFitness.jpg",
    hatha: "/images/HathaYoga_Studio_CaboYogaFitness.jpg",
    barre: "/images/Barre_Class_CaboYogaFitness.jpg",
    sculpt: "/images/Sculpt_Studio_CaboYogaFitness.jpg",
    fullBody: "/images/FullBodyWorkout_Class_CaboYogaFitness.jpg",
    vibrationalMovement: "/images/VibrationalMovement_CaboYogaFitness.jpg",
  },
  homeClasses: {
    barre: "/images/Barre_Studio_CaboYogaFitness.jpg",
    sculpt: "/images/Sculpt_Studio_CaboYogaFitness.jpg",
    fullBody: "/images/FullBodyWorkout_Studio_CaboYogaFitness.jpg",
  },
  soundHealing: {
    hero: "/images/SoundHealing_Hero_CaboYogaFitness.jpg",
    portraitOne: "/images/SoundHealing_Studio_CaboYogaFitness.jpg",
    portraitTwo: "/images/CrystalSingingBowls_LosCabos_CaboYogaFitness.jpg",
  },
  trainers: {
    erin: "/images/Erin_CaboYogaFitness.jpg",
    liza: "/images/Liza_CaboYogaFitness.jpg",
    alma: "/images/Alma_CaboYogaFitness.jpg",
    sophia: "/images/Sophia_CaboYogaFitness.jpg",
    magda: "/images/MagdaWilk_CaboYogaFitness.webp",
    emilia: "/images/EmiliaMoran_CaboYogaFitness.webp",
    alex: "/images/Alex_CaboYogaFitness.jpg",
    carla: "/images/Carla_CaboYogaFitness.jpg",
    estefania: "/images/Estefania_CaboYogaFitness.jpg",
  },
};
